import "../css/styles.css";

// Components
// ---------------------------------
import Accordion from "./components/accordion";
import Analytics from "./components/analytics";
import QuoteForm from "./components/quote-form";
import QuotesCarousel from "./components/quotes-carousel";
import TestimonialsCarousel from "./components/testimonials-carousel";
import Video from "./components/video";
import Menu from "./components/menu";

// Helpers
// ---------------------------------
import { detectIE, enableJS } from "./utils";

/**
 * @class App
 * A basic class to hold instances of modules
 * Any other global config can be setup here
 */
class App {
  constructor() {
    // Components
    // ---------------------------------
    new Accordion();
    new Analytics();
    new QuotesCarousel();
    new TestimonialsCarousel();
    new Video();
    new Menu();

    // Helpers
    // ---------------------------------
    detectIE();
    enableJS();

    window.dispatchEvent(new Event("scroll"));
  }
}

// Ready
// ---------------------------------
document.addEventListener("DOMContentLoaded", () => new App());

window.onGoogleMapsLoaded = () => {
  return new QuoteForm();
};
